import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Ticket, BadgeCheck } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { API, useAuth } from "../App";
import { formatApiError } from "../lib/utils";

const fmt = (iso) => new Date(iso).toLocaleDateString("en-ZA", { day: "numeric", month: "long", year: "numeric" });

export const PromoRedeemCard = () => {
  const { user, checkAuth } = useAuth();
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user?.promo_active) {
    return (
      <div className="bg-zinc-900 border border-orange-600/60 p-6 flex items-start gap-3" data-testid="promo-active-card">
        <BadgeCheck className="h-6 w-6 text-teal-500 shrink-0" />
        <div>
          <p className="text-white">Pro plan · free with code <span className="font-mono text-orange-500" data-testid="promo-active-code">{user.promo_code}</span></p>
          <p className="text-zinc-400 text-sm mt-1" data-testid="promo-active-expiry">
            Granted {fmt(user.promo_granted_at)} · returns to Free on {fmt(user.promo_expires_at)}
          </p>
        </div>
      </div>
    );
  }

  const redeem = async (e) => {
    e.preventDefault();
    if (!code.trim()) return setError("Enter a promo code");
    setBusy(true);
    setError("");
    try {
      const r = await axios.post(`${API}/promo/redeem`, { code }, { withCredentials: true });
      toast.success(r.data.message);
      setCode("");
      await checkAuth();
    } catch (err) {
      setError(formatApiError(err, "Could not apply promo code"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={redeem} className="bg-zinc-900 border border-zinc-800 p-6" data-testid="promo-redeem-card">
      <h3 className="font-heading text-xl text-white mb-1 flex items-center gap-2"><Ticket className="h-5 w-5 text-orange-500" /> Have a promo code?</h3>
      <p className="text-zinc-500 text-sm mb-4">Unlock the Pro plan and a verified badge on your profile.</p>
      <div className="flex flex-col sm:flex-row gap-3">
        <Input value={code} onChange={(e) => { setCode(e.target.value.toUpperCase()); setError(""); }} placeholder="PROMO CODE"
          className="bg-zinc-800 border-zinc-700 font-mono uppercase" data-testid="promo-redeem-input" />
        <Button type="submit" disabled={busy} className="bg-orange-600 hover:bg-orange-500" data-testid="promo-redeem-btn">
          {busy ? "Applying…" : "Apply code"}
        </Button>
      </div>
      {error && <p className="text-red-400 text-sm mt-2" data-testid="promo-redeem-error">{error}</p>}
    </form>
  );
};
